import { useEffect, useState } from 'react';

export const useSwitch = (value?: boolean) => {
  const [switchState, setSwitchState] = useState(false);

  useEffect(() => {
    setSwitchState(Boolean(value));
  }, [value]);

  return { switchState, onChange: (value: boolean) => setSwitchState(value) };
};
